import constants from './constants'
import useSubmitBtn from './useSubmitBtn'
import useFields from './useFields'
import useLogin from './useLogin'
import useGoRegisterBtn from './useGoRegisterBtn'
import useSamlAuth from './useSamlAuth'
import useSetUserData from './useSetUserData'

export default { constants, useSetUserData, useLogin, useSamlAuth, useGoRegisterBtn, useFields, useSubmitBtn }
export { constants }